import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-lines, note, card, text"} maskId="square-filled-radius-0-stroke-1-IconSquareLines"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM7 14H15V15H7V14ZM7 9V10H17V9H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareLines;
